import { SignUpPromotionAction } from '../actions/sign_up_promotion_action';
import { SignUpPromotionContainer } from '../views/pc/sign_up_promotion_container';

document.addEventListener('DOMContentLoaded', () => {
  SignUpPromotionAction.init(SignUpPromotionContainer);
});
